import React from 'react';
import './CartItem.css';

export default function CartItem({ item, onUpdateQuantity, onRemove }) {
  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return null;

    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
      return imageUrl;
    }

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const cleanPath = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
    return `${baseUrl}${cleanPath}`;
  };

  // ✅ Calculate effective (discounted) price
  const getEffectivePrice = () => {
    const price = parseFloat(item.price);
    const disc = parseFloat(item.discount_percent);
    if (!disc || isNaN(disc) || disc <= 0) return null;
    return parseFloat((price - (price * disc) / 100).toFixed(2));
  };

  const imageUrl = getImageUrl(item.image_url);
  const emoji = item.category === 'fruits' ? '🍎' : item.category === 'meat' ? '🥩' : '🥬';

  const discountedPrice = getEffectivePrice();
  const hasDiscount = discountedPrice !== null;
  const effectivePrice = hasDiscount ? discountedPrice : parseFloat(item.price);
  const subtotal = parseFloat((effectivePrice * item.quantity).toFixed(2));
  const originalSubtotal = parseFloat((parseFloat(item.price) * item.quantity).toFixed(2));

  return (
    <div className="cart-item">
      <div className="cart-item-image">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={item.name}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div className="cart-item-emoji" style={{ display: imageUrl ? 'none' : 'flex' }}>
          {emoji}
        </div>

        {/* ✅ Discount badge on cart item image */}
        {hasDiscount && (
          <div className="cart-discount-badge">
            {item.discount_percent}% OFF
          </div>
        )}
      </div>

      <div className="cart-item-info">
        <h3 className="cart-item-name">{item.name}</h3>

        {/* ✅ Price: show strikethrough if discounted */}
        {hasDiscount ? (
          <div className="cart-item-price-row">
            <span className="cart-price-original">Rs. {item.price}</span>
            <span className="cart-price-discounted">Rs. {discountedPrice}</span>
            <span className="cart-price-unit">/{item.unit}</span>
          </div>
        ) : (
          <p className="cart-item-price">Rs. {item.price}/{item.unit}</p>
        )}

        {/* ✅ Subtotal with savings note */}
        <p className="cart-item-subtotal">Subtotal: Rs. {subtotal}</p>
        {hasDiscount && (
          <p className="cart-item-savings">
            🎉 You save Rs. {(originalSubtotal - subtotal).toFixed(2)}
          </p>
        )}
      </div>

      <div className="cart-item-actions">
        <div className="quantity-controls">
          <button
            className="quantity-btn"
            onClick={() => onUpdateQuantity(item.id, -1)}
            disabled={item.quantity <= 1}
          >
            −
          </button>
          <span className="quantity-value">{item.quantity}</span>
          <button
            className="quantity-btn"
            onClick={() => onUpdateQuantity(item.id, 1)}
          >
            +
          </button>
        </div>

        <button
          className="remove-btn"
          onClick={() => onRemove(item.id)}
          title="Remove from cart"
        >
          🗑️
        </button>
      </div>
    </div>
  );
}